import axios from '../Services/Axios.service';

const setAuthHeader = token => {
  axios.defaults.headers.common['X-Auth-Token'] = token;
};

export default setAuthHeader;
